/**
 * CSSの値（vw、em、rem、%など）をピクセル数値に変換するよ！
 * @param {string} cssValue - 変換したいCSS値（例：'20vw', '1.5rem', '100px'）
 * @returns {number} ピクセル値
 * @example
 * // 使い方
 * const element = document.querySelector('.my-element');
 * const borderRadius = getComputedValueInPixels(element, 'borderRadius');
 * console.log(borderRadius); // 例：16
 */
const getComputedValueInPixels = (element, property) => {
    const value = window.getComputedStyle(element)[property];
    return parseFloat(value);
};

export const topInit = () => {
    if (document.body.classList.contains("home")) {
        //slides
        const slidesElm = document.querySelector(".slides"),
            slidesScrollElm = document.querySelector(".slides__scroll"),
            svh = document.querySelector(".Svh"),
            lvh = document.querySelector(".Lvh"),
            targetElm = document.querySelector(".slides__scrollBlock .l-3"),
            targetVideoElm = document.querySelector(
                ".slides__scrollBlock .l-3 video"
            ),
            targetDummyElm = document.querySelector(
                ".slides__scrollBlock .l-3 .dummy"
            ),
            otherVideos = document.querySelectorAll(
                ".slides__scrollBlock .l-1,.slides__scrollBlock .l-2,.slides__scrollBlock .l-4"
            );

        let offsetHeight = 0;

        const init = () => {
            const tdeInfo = targetDummyElm.getBoundingClientRect();
            offsetHeight =
                (lvh.getBoundingClientRect().height - tdeInfo.height) / 2;
            slidesScrollElm.style.top = `${offsetHeight}px`;
            slidesElm.style.marginBottom = `${-offsetHeight}px`;
        };

        const scroll = () => {
            const seInfo = slidesElm.getBoundingClientRect();
            const seInfoNTop = -seInfo.top + offsetHeight,
                seInfoHeight =
                    seInfo.height -
                    offsetHeight -
                    lvh.getBoundingClientRect().height;

            const tdeInfo = targetDummyElm.getBoundingClientRect();

            const sbInfo = slidesElm
                .querySelector(".screenleftbase")
                .getBoundingClientRect();
            const l3lbInfo = slidesElm
                .querySelector(".l-3-leftbase")
                .getBoundingClientRect();

            let progress = 0;

            if (seInfoNTop >= 0 && seInfoNTop <= seInfoHeight) {
                progress = seInfoNTop / seInfoHeight;
            } else if (seInfoNTop > seInfoHeight) {
                progress = 1;
            }

            const max = {
                width: innerWidth / tdeInfo.width - 1,
                height: lvh.getBoundingClientRect().height / tdeInfo.height - 1,
                bora: getComputedValueInPixels(targetDummyElm, "borderRadius"),
                left: l3lbInfo.left - sbInfo.left,
            };

            targetElm.style.width = `${
                (max.width * progress + 1) * tdeInfo.width
            }px`;

            targetElm.style.height = ` ${
                (max.height * progress + 1) * tdeInfo.height
            }px`;

            targetVideoElm.style.borderRadius = `${
                max.bora * (1 - progress)
            }px`;

            slidesScrollElm.style.translate = `${max.left * -progress}px ${
                offsetHeight * -progress
            }px`;

            otherVideos.forEach((v) => {
                v.style.opacity = `${1 - progress}`;
            });
        };

        const resize = () => {
            init();
            scroll();
        };

        resize();

        window.addEventListener("scroll", scroll);
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("scroll", scroll);
            window.removeEventListener("resize", resize);
        };
    }

    return () => {};
};
